import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLockDeviceMutation as useLockDeviceMdmMutation } from '@/redux/slices/mdmManagementApiSlice';
import { useLockDeviceMutation as useLockDeviceCoreEntityMutation } from '@/redux/slices/deviceApiSlice';
import { LockArgs } from '@/types/mdmManagement';

export const useLockDeviceCompat = () => {
  const { byoMdmLockAndWipe } = useFlags();
  const [lockDeviceMdm, mdmState] = useLockDeviceMdmMutation();
  const [lockDeviceCoreEntity, coreEntityState] =
    useLockDeviceCoreEntityMutation();

  const lockDevice = (args: LockArgs) =>
    byoMdmLockAndWipe ? lockDeviceCoreEntity(args) : lockDeviceMdm(args);

  return [lockDevice, byoMdmLockAndWipe ? coreEntityState : mdmState] as const;
};
